site.searchDrop = {
	init: function () {
		$('.search-drop #searchForm').attr('id', 'searchFormDrop');
		$('.search-drop #q').attr('id', 'q-drop');

		$('.search-toggler').click(function (e) {
			$('body').addClass('open-search');
			$('#q-drop').focus();
			e.stopPropagation();
		});

		$('body').click(function (e) {
			$('body').removeClass('open-search');
		});

		$('.search-closer').click(function (e) {
			$('body').removeClass('open-search');
		});

		$('.search-drop').click(function (e) {
			e.stopPropagation();
		});

		// Close search if escape key is pressed
		$(document).keyup(function (e) {
			if (e.keyCode == 27) {
				$('body').removeClass('open-search');
			}
		});
	}
};

site.inits.push('site.searchDrop.init()');
